// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"SortableDndItem_dropzone__3svx2"};